import formatDate from "astrid-helpers/src/formatDate";

import articleDeliveryTypes from "../../articles/constants/articleDeliveryTypes";
import articleTypes from "../../articles/constants/articleTypes";
import contributorRoles from "../../articles/constants/contributorRoles";
import getArticleChannelData from "../../articles/getArticleChannelData";

export function channelSupportsArticle({ article, channel, deliveryType }) {
	if (!channel.active) {
		return false;
	}

	return channelAcceptsArticle({ article, channel, deliveryType });
}

export function channelAcceptsArticle({ article, channel, deliveryType }) {
	const { acceptedArticleTypes, acceptedLanguages, acceptedDeliveryTypes } = channel;

	// If the channel has accepted article types, and the article type is not in the list, return false
	if (acceptedArticleTypes?.length > 0 && !acceptedArticleTypes.includes(article.type)) {
		return false;
	}

	// If the channel has accepted languages, and the article language is not in the list, return false
	if (acceptedLanguages?.length > 0 && !acceptedLanguages.includes(article.language)) {
		return false;
	}

	// If the channel has accepted delivery types, and the delivery type is not in the list, return false
	if (deliveryType && acceptedDeliveryTypes?.length > 0 && !acceptedDeliveryTypes.includes(deliveryType)) {
		return false;
	}

	return true;
}

export function canDeliverArticleToChannel({ article, channel, deliveryType, now = new Date() }) {
	if (!channelSupportsArticle({ article, channel, deliveryType })) {
		return false;
	}

	if (!article.channelIds.includes(channel.id)) {
		return false;
	}

	if (
		deliveryType &&
		article?.channels?.[channel.id]?.deliveryTypes &&
		!article.channels[channel.id].deliveryTypes.includes(deliveryType)
	) {
		return false;
	}

	if (deliveryType === articleDeliveryTypes.ARTIFACT) {
		if (!article?.artifact?.ref) {
			// if the article does not have files, return false
			return false;
		}

		const takedownDate = getArticleChannelData(article, channel.id, "takedownDate");

		if (!channel.forceDeliveryOfMetadataAndFilesSimultaneously && takedownDate && takedownDate <= formatDate(now)) {
			return false;
		}
	}

	if (deliveryType === articleDeliveryTypes.METADATA) {
		if (!article.name || !article.isbn) {
			return false;
		}
	}

	return true;
}

export function canDeliverArticlesToChannels({ articles, channel, deliveryType, now = new Date() }) {
	return articles.some((article) => canDeliverArticleToChannel({ article, channel, deliveryType, now }));
}
